// client/src/admin/dashboard/Content.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { TranslateContext } from "../../context/TranslateContext";

import AdminHome from "./AdminHome";
import ManageUsers from "../manage-users/ManageUsers";
import AdminSupportTickets from "../support/AdminSupportTickets";
import InstagramSettings from "../instagram/InstagramSettings";
import FlowBuilder from "../instagram/FlowBuilder";
import FollowClaims from "../instagram/FollowClaims";
import AdminPopups from "../popups/AdminPopups"; // ← ADD

const Content = ({ selectedMenu, menuItems = [] }) => {
  const { lang } = React.useContext(TranslateContext);

  return (
    <div>
      {selectedMenu === "dashboard" && <AdminHome />}
      {selectedMenu === "manage-users" && <ManageUsers lang={lang} />}
      {selectedMenu === "support-tickets" && (
        <AdminSupportTickets lang={lang} />
      )}
      {selectedMenu === "popup-manager" && <AdminPopups lang={lang} />}{" "}
      {/* ← ADD */}
      {selectedMenu === "instagram-settings" && (
        <InstagramSettings lang={lang} />
      )}
      {selectedMenu === "flow-builder" && <FlowBuilder lang={lang} />}
      {selectedMenu === "follow-claims" && <FollowClaims lang={lang} />}
    </div>
  );
};

export default Content;
